<div class="modal-container">
  <div class="modal-header">
    <h2 mat-dialog-title>Solicitud Activa Encontrada</h2>
  </div>
  
  <div mat-dialog-content class="modal-content">
    <div class="alert-icon">
      <mat-icon class="warning-icon">warning</mat-icon>
    </div>
    <p class="alert-message" *ngIf="data.mensaje; else mensajePorDefecto">
      {{ data.mensaje }}
    </p>
    <ng-template #mensajePorDefecto>
      <p class="alert-message">
        El contrato seleccionado presenta una solicitud activa, identificada con el número
        <strong>{{ data.numeroSolicitud }}</strong>, que corresponde al mismo tipo de
        novedad y está asociada a uno o más de los miembros indicados.
      </p>
    </ng-template>
  </div>
  
  <div mat-dialog-actions class="modal-actions">
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onClose($event)"
      cdkFocusInitial>
      Cerrar
    </button>
  </div>
</div>